<template>
  <div class="app-filter-wrapper custom-wrapper">

    <div class="filter-wrapper">
      <el-form
        label-position="right"
        label-width="100px"
        ref="filterForm"
        :model="filterForm">

        <el-form-item
          label="应用分类"
          prop="app_category_id"
          v-if="hasRes('store_app_category_index')" >
          <el-select
            filterable
            default-first-option
            v-model="filterForm.app_category_id" >
            <el-option label="全部" value="" />
            <el-option
              v-for="appCategory in appCategoryList"
              :key="appCategory.app_category_id"
              :label="appCategory.app_category_name_i18n[0].name"
              :value="appCategory.app_category_id" />
          </el-select>
        </el-form-item>

        <el-form-item label="应用类别" prop="app_type">
          <el-select
            default-first-option
            v-model="filterForm.app_type">
            <el-option label="全部" value="" />
            <el-option label="商户应用" value="user" />
            <el-option label="代理商应用" value="agent" />
          </el-select>
        </el-form-item>

      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onFilterSubmit">查询</el-button>
        <el-button
          size="medium"
          @click="onFilterReset">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_PAGE, SET_FILTERS } from '@/store/modules/table'

export default {
  name: 'AppFilter',
  data () {
    return {
      filterForm: {
        app_category_id: '',
        app_type: ''
      }
    }
  },
  computed: {
    ...mapState('store', [
      'appCategoryList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_PAGE,
      SET_FILTERS
    ]),
    ...mapActions('store', [
      'getAppCategories'
    ]),

    async getSelectDatas () {
      if (this.hasRes('store_app_category_index')) {
        try {
          await this.getAppCategories({
            page: 1,
            pageSize: 9999
          })
        } catch (err) {
          console.log(err)
        }
      }
    },

    onFilterSubmit () {
      this.setPage(1)

      const filters = Object.assign({}, this.filterForm)
      filters.app_category_id === '' && delete filters.app_category_id
      filters.app_type === '' && delete filters.app_type
      this.setFilters(filters)
      this.$emit('filter')
    },
    onFilterReset () {
      this.$refs['filterForm'].resetFields()
      this.filterForm.app_category_id = ''
    }
  },
  mounted () {
    this.getSelectDatas()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/base.scss';

.app-filter-wrapper {
}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/StoreAppFilter.vue